import { render, staticRenderFns } from "./TrailerRentalReefer.vue?vue&type=template&id=4d779585&"
import script from "./TrailerRentalReefer.vue?vue&type=script&lang=js&"
export * from "./TrailerRentalReefer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports